module.exports = __webpack_public_path__ + "static/img/40020 (2).bb6836b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40020 (2).webp
// module id = 8b7o
// module chunks = 14